import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Select from "react-select";

import { adminMainUrl } from '../../../../Config';

import ServiceTab from './General/ServiceTab';
import EntityTab from './General/EntityTab';
import FreightTab from './General/FreightTab';
import CustomsTab from './General/CustomsTab';
import TransportTab from './General/TransportTab';
import CargoDtlsTab from './General/CargoDtlsTab';
import EstimatesTab from './General/EstimatesTab';
import { getJobOrderDetails, getJobOrderEmployeeList, getJobOrderServiceDetails, getUnusedQuotationList } from '../../../../Redux/action/Joborder/JoborderAction';
import { useFormik } from 'formik';
import axios from 'axios';
import JobOrderEditOffcanvas from './JobOrderEditOffcanvas';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import FreightAirTab from './General/FreightAirTab';
import FreightSeaTab from './General/FreightSeaTab';
import { getMasterIATAAgent } from '../../../../Redux/action/MasterAction';

const JobOrderEdit = ({ accessedModules, accessedPermission }) => {
    const { b64id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [activeTab, setActiveTab] = useState("service");

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
            dispatch(getMasterIATAAgent(token, user_id));
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderDetails(token, user_id, id))
                    dispatch(getJobOrderServiceDetails(token, user_id, id));

                }
            } else {
                toast.error("Invalid Order ID.")
                navigate(-1);
            }
            dispatch(getUnusedQuotationList(token, user_id));
            dispatch(getJobOrderEmployeeList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }

    }, [token, user_id]);


    const refresh = () => {
        if (token && user_id) {
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderDetails(token, user_id, id));
                    dispatch(getJobOrderServiceDetails(token, user_id, id));
                }
            } else {
                toast.error("Invalid Order ID.")
                navigate(-1);
            }
        }
    };

    const refreshService = () => {
        if (token && user_id) {
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderServiceDetails(token, user_id, id));
                }
            } else {
                toast.error("Invalid Order ID.")
                navigate(-1);
            }
        }
    };


    const {
        loadingUnusedQuotationList,
        UnusedQuotationListError,
        UnusedQuotationList,

        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,

        loadingJobOrderDetail,
        JobOrderDetail,
        JobOrderDetailError,

        loadingJobOrderServiceDetail,
        JobOrderServiceDetailError,
        JobOrderServiceDetail,

    } = useSelector(state => state?.JoborderReducer);

    const {
        loadingMasterIATAAgent,
        MasterIATAAgent,
        MasterIATAAgentError

    } = useSelector(state => state?.MasterReducer);


    const [iataAgentOptions, setIATAAgentOptions] = useState([]);
    useEffect(() => {
        if (MasterIATAAgent) {
            let arr = [];
            MasterIATAAgent.map(v => { arr.push({ value: v.id, label: `${v.name} - ${v.iata_code}` }) });
            setIATAAgentOptions(arr);
        } else {
            setIATAAgentOptions([]);
        }
    }, [MasterIATAAgent])




    //tab disablitiy
    const [disableFreight, setDisableFreight] = useState(true);
    const [disableCustoms, setDisableCustoms] = useState(true);
    const [disableTransport, setDisableTransport] = useState(true);
    const [disableTabs, setDisableTabs] = useState(true);

    useEffect(() => {
        if (JobOrderServiceDetail) {
            setDisableTabs(false);
            if (JobOrderServiceDetail.is_freight) {
                setDisableFreight(false);
            } else {
                setDisableFreight(true);
            }

            if (JobOrderServiceDetail.is_customs) {
                setDisableCustoms(false);
            } else {
                setDisableCustoms(true);
            }

            if (JobOrderServiceDetail.is_transport) {
                setDisableTransport(false);
            } else {
                setDisableTransport(true);
            }
        } else {
            setDisableTabs(true);
            setDisableFreight(true);
            setDisableCustoms(true);
            setDisableTransport(true);
            setDisableTabs(true);
        }
    }, [JobOrderServiceDetail])






    const [showEditJobOrder, setShowEditJobOrder] = useState(false);
    const handleShowEditJobOrder = () => { setShowEditJobOrder(true) };
    const handleCloseEditJobOrder = () => { setShowEditJobOrder(false) };





    const [quotationOption, setQuotationOptions] = useState([]);
    const [loadingQuotation, setLoadingQuotation] = useState(false);

    const [branchOption, setBranchOption] = useState([]);
    const [loadingBranch, setLoadingBranch] = useState(false);

    const [companyName, setCompanyName] = useState("");

    useEffect(() => {
        if (loadingUnusedQuotationList) {
            setLoadingQuotation(true);
        } else {
            setLoadingQuotation(false);
        }

        if (UnusedQuotationList) {
            let arr = [];
            UnusedQuotationList.map((val) => arr.push({ value: val.id, label: val.ship_quotation_no }));
            setQuotationOptions(arr);
        }
    }, [loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList]);


    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loadingEmployee, setLoadingEmployee] = useState([]);

    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setLoadingEmployee(true);
        } else {
            setLoadingEmployee(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);

    const initialValues = {
        trans_mode: "",
        trans_type: "",
        quotation_id: "",
        customer_id: "",
        customer_branch_id: "",
        job_owner_id: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/jobOrder/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`/flexichain/jobOrder/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const handleChangeCompanyBranch = (quotation_id) => {
        try {
            formik.setFieldValue("customer_id", "");
            formik.setFieldValue('branch_id', "");
            let config = { headers: { 'auth-token': token, 'user_id': user_id } };
            axios.get(`${adminMainUrl}/api/jobOrder/get-companydetails-on-quotation?quotation_id=${quotation_id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data) {
                            if (response.data.data) {
                                if (response.data.data.customer_data) {
                                    formik.setFieldValue('customer_id', response.data.data.customer_data.id);
                                    setCompanyName(`${response.data.data.customer_data?.name} ${response.data.data.customer_data?.alias ? `(${response.data.data.customer_data?.alias})` : ""} - ${response.data.data.customer_data?.customerType}`);
                                    if (response.data.data.customer_data?.customer_branch) {
                                        if (Array.isArray(response.data.data.customer_data?.customer_branch)) {
                                            let arr = [];
                                            response.data.data.customer_data?.customer_branch.map(val => arr.push({ value: val.id, label: val.branch_name }));
                                            setBranchOption(arr);
                                        } else {
                                            setBranchOption([]);
                                        }
                                    } else {
                                        setBranchOption([]);
                                    }
                                } else {
                                    setCompanyName("");
                                    formik.setFieldValue('customer_id', "");
                                    setBranchOption([]);
                                }
                            }
                        }
                    } else {
                        console.log(response.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
        } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
        }
    }

    let [transmode, setTransMode] = useState("Air");
    let [transtype, setTransType] = useState("Import");
    useEffect(() => {
        if (loadingJobOrderDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        };

        if (JobOrderDetail) {
            // console.log(JobOrderDetail);
            setTransMode(JobOrderDetail?.trans_mode);
            setTransType(JobOrderDetail?.trans_type);
            formik.setFieldValue("trans_mode", JobOrderDetail?.trans_mode);
            formik.setFieldValue("trans_type", JobOrderDetail?.trans_type);
            formik.setFieldValue("quotation_id", JobOrderDetail?.quotation_id);
            formik.setFieldValue("customer_id", JobOrderDetail?.customer_id);
            formik.setFieldValue("customer_branch_id", JobOrderDetail?.customer_branch_id);
            formik.setFieldValue("job_owner_id", `${JobOrderDetail?.job_owner_id}`);
        };


    }, [loadingJobOrderDetail, JobOrderDetail, JobOrderDetailError])


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="card">
                                    <div className="card-body">
                                        {/* Filter */}
                                        <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">

                                                <div className="row">
                                                    <div className="row d-flex">
                                                        <div className="col-md-6 d-flex">
                                                            <Link to='/flexichain/job-order' className="d-flex justify-content-center align-item-center" title='Go to Job List'>
                                                                <i className="fa-solid fa-arrow-left text-blue me-2"></i>
                                                            </Link>
                                                            <h6>
                                                                Job Order
                                                            </h6>
                                                        </div>
                                                        <div className="col-md-6 d-flex justify-content-end">
                                                            <button className="btn btn-sm btn-primary" onClick={() => handleShowEditJobOrder()}>
                                                                <i className="fas fa-edit"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Job Order No.
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.job_order_unique_no : "-"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Tracking No.
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.tracking_no : "-"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Transport Mode
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.trans_mode : "-"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Transport Type
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.trans_type : "-"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Has Quotation
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.has_quotation ? "Yes" : "No" : "-"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Direct Customer
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ? JobOrderDetail?.is_direct_customer ? "Yes" : "No" : "-"}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2 input_box_section'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Quotation
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                {JobOrderDetail ?
                                                                    JobOrderDetail?.has_quotation ?
                                                                        JobOrderDetail?.quote_export_info ?
                                                                            JobOrderDetail?.quote_export_info?.ship_quotation_no ?? "-"
                                                                            :
                                                                            "-"
                                                                        :
                                                                        "-"
                                                                    :
                                                                    <i>No Quotation</i>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2 input_box_section'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Customer
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">

                                                                {JobOrderDetail ?
                                                                    JobOrderDetail?.customer_detail ?
                                                                        JobOrderDetail?.customer_detail?.name ?? "-"
                                                                        :
                                                                        "-"
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Branch
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">

                                                                {JobOrderDetail ?
                                                                    JobOrderDetail?.customer_branch_detail ?
                                                                        JobOrderDetail?.customer_branch_detail?.branch_name ?? "-"
                                                                        :
                                                                        "-"
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 mt-2">
                                                        <div className='ms-2 input_box_section'>
                                                            <label htmlFor="" className='form-label  mb-0'>
                                                                Job Owner
                                                            </label>
                                                            <div className="icon-forms mb-3 mb-sm-0">

                                                                {JobOrderDetail ?
                                                                    JobOrderDetail?.user_info ?
                                                                        JobOrderDetail?.user_info?.name ?? "-"
                                                                        :
                                                                        "-"
                                                                    :
                                                                    "-"
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        {/* /Filter */}
                                        {/* Contact List */}

                                        <div className="row-gap-2">
                                            <div className="tab-content" id="pills-tabContent">
                                                <Tabs
                                                    activeKey={activeTab} // Controlled by state
                                                    onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                                    transition={false}
                                                    id="noanim-tab-example"
                                                    className="nav nav-pills mb-3 custom-tabs gap-0"
                                                >
                                                    <Tab eventKey="service" title="Service" className="nav-item">
                                                        <ServiceTab
                                                            token={token}
                                                            user_id={user_id}
                                                            b64id={b64id}
                                                            loadingJobOrderEmployeeList={loadingJobOrderEmployeeList}
                                                            JobOrderEmployeeListError={JobOrderEmployeeListError}
                                                            JobOrderEmployeeList={JobOrderEmployeeList}
                                                            loadingJobOrderServiceDetail={loadingJobOrderServiceDetail}
                                                            JobOrderServiceDetailError={JobOrderServiceDetailError}
                                                            JobOrderServiceDetail={JobOrderServiceDetail}
                                                            refreshService={refreshService}
                                                            JobOrderDetail={JobOrderDetail}
                                                            refreshJobOrder={refresh}
                                                        />
                                                    </Tab>
                                                    <Tab eventKey="entity" title="Entity" className="nav-item" disabled={disableTabs}>
                                                        <EntityTab token={token} user_id={user_id} b64id={b64id} JobOrderDetail={JobOrderDetail} />
                                                    </Tab>
                                                    <Tab eventKey="freight" title="Freight" className="nav-item" disabled={disableFreight}>
                                                        {/* <FreightTab token={token} user_id={user_id} b64id={b64id} transmode={transmode} /> */}
                                                        {
                                                            JobOrderDetail?.trans_mode == "Air" ?

                                                                <FreightAirTab token={token} user_id={user_id} b64id={b64id} transmode={transmode} iataAgentOptions={iataAgentOptions} />
                                                                :
                                                                <FreightSeaTab token={token} user_id={user_id} b64id={b64id} transmode={transmode} iataAgentOptions={iataAgentOptions} />

                                                        }
                                                    </Tab>
                                                    <Tab eventKey="custom" title="Customs" className="nav-item" disabled={disableCustoms}>
                                                        <CustomsTab token={token} user_id={user_id} b64id={b64id} />
                                                    </Tab>
                                                    <Tab eventKey="transport" title="Transport" className="nav-item" disabled={disableTransport}>
                                                        <TransportTab token={token} user_id={user_id} b64id={b64id} transmode={transmode} transtype={transtype} />
                                                    </Tab>
                                                    <Tab eventKey="cargodtls" title="Cargo Dtls" className="nav-item" disabled={disableTabs}>
                                                        <CargoDtlsTab token={token} user_id={user_id} b64id={b64id} transmode={transmode} transtype={transtype} />
                                                    </Tab>
                                                    {/* <Tab eventKey="estimates" title="Estimates" className="nav-item" disabled={disableTabs}>
                                                        <EstimatesTab token={token} user_id={user_id} b64id={b64id} />
                                                    </Tab> */}
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >

                        <JobOrderEditOffcanvas
                            show={showEditJobOrder}
                            handleClose={handleCloseEditJobOrder}

                            loadingUnusedQuotationList={loadingUnusedQuotationList}
                            UnusedQuotationListError={UnusedQuotationListError}
                            UnusedQuotationList={UnusedQuotationList}

                            loadingJobOrderEmployeeList={loadingJobOrderEmployeeList}
                            JobOrderEmployeeListError={JobOrderEmployeeListError}
                            JobOrderEmployeeList={JobOrderEmployeeList}

                            JobOrderDetail={JobOrderDetail}
                            b64id={b64id}

                            token={token}
                            user_id={user_id}

                            refresh={refresh}
                        />
                    </>
            }

        </>


    )
}

export default JobOrderEdit